import { animate_text, split_text } from './text-animation';

// Slim masthead animates word by word using the shared text animation
function animate_masthead(masthead) {
    // Grab all headings
    const headings = $(masthead).find('.mh-copy h1, .mh-copy h2');
    const isSlider = $(masthead).is('[data-mh-type="slider"]');

    if(isSlider) {
        // Split every title the same way. Playback runs on each slide change.
        headings.each(function() {
            split_text($(this));
        });
    } else {
        animate_text(headings.eq(0));
    }

    // Show heading
    headings.css('display', 'block');
}

$(() => {
    let $masthead = $('mimas-masthead');

    // Check if masthead exists
    if($masthead.length) {
        $masthead.each(function(_, m) {
            animate_masthead(m);
        })
    }
});
